import api from './api';

export default class AvaliadorEstagioProbatorioService {
  constructor() {
    throw 'Não é possível instanciar AvaliadorEstagioProbatorioService';
  }

  static async lista(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = (id, idMes) => {
  return `avaliacoes-estagio-probatorio/avaliadores/${id}/competencias/${idMes}/totais`;
};



// WEBPACK FOOTER //
// ./src/services/avaliadorEstagioProbatorioService.js